import { InputAdornment } from "@mui/material";
import "../Login/Login.css";
import { Link, useNavigate } from "react-router-dom";
import { ChangeEvent, useEffect, useState } from "react";
// import { baseUrl } from "../Utils/common";
import { useSnackbar } from "../../context/SnackbarContext";
import emailIcon from "../../assets/login_mail.svg";
import HomeNavbar from "../../Components/HomeNavbar/HomeNavbar";
import { forgotPassword, verifyResetOtp } from "../../api/auth";
import { useForm } from "react-hook-form";
import { ForgotPasswordSchema, ForgotPasswordSchemaType } from "./LoginSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import CreatePasswordForm from "./CreatePasswordForm";
import TextField from "../../Components/TextField";
import { images } from "../../assets/images";

const ForgetPassword = () => {
  const { register, handleSubmit, formState, watch } =
    useForm<ForgotPasswordSchemaType>({
      mode: "onTouched",
      resolver: yupResolver(ForgotPasswordSchema),
      defaultValues: { email: "" },
    });

  const emailValue = watch("email");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => setErrorMessage(""), [emailValue]);

  const { showSnackbar } = useSnackbar();
  const [, setLoading] = useState(false);
  const navigate = useNavigate();

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [countdown, setCountdown] = useState(40); // Countdown timer in seconds
  const [resendDisabled, setResendDisabled] = useState(true); // Disable resend button initially
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const handleOtpChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.target.value;
    const newOtp = [...otp];
    newOtp[index] = value;

    setOtp(newOtp);

    setSubmitDisabled(newOtp.some((val) => val === ""));

    // If user entered a value and it's not empty, focus on the next input box
    if (value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }

    // If the value is empty (user deleted), focus on the previous input box
    if (!value && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      prevInput?.focus();
    }
  };

  const [step, setStep] = useState(0);

  useEffect(() => {
    if (countdown === 0) {
      setResendDisabled(false); // Enable resend button when countdown finishes
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer); // Cleanup interval on unmount or when countdown reaches 0
  }, [countdown, step]);

  const [showCreateBtn, setShowCreateBtn] = useState(false);

  // const [success, setSuccess] = useState(false);
  const forgetPassword = async (e: ForgotPasswordSchemaType) => {
    setLoading(true);

    try {
      const response = await forgotPassword(e.email);

      if (response.data.data) {
        showSnackbar(response.data.responseInfo?.description, "success");
        setErrorMessage("");
        setStep(1);
      } else {
        if (
          response.data.responseInfo?.description ===
          "This email is not registered before."
        )
          setShowCreateBtn(true);
        setErrorMessage(response.data.responseInfo?.description);
        // showSnackbar(response.data.responseInfo?.description, "error");
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
    setLoading(false);
  };
  // const [success, setSuccess] = useState(false);
  const resendCode = async () => {
    // Reset the countdown and disable the "Resend code" button
    setOtp(["", "", "", ""]);
    setCountdown(40);
    setResendDisabled(true);
    setSubmitDisabled(true); // Disable the submit button until OTP is entered

    setLoading(true);

    try {
      // Call the forgotPassword function with the email value
      const response = await forgotPassword(emailValue);

      // Handle success response
      if (response.data.data) {
        showSnackbar(response.data.responseInfo?.description, "success");
        setErrorMessage(""); // Clear any error messages
        setStep(1); // Move to the next step (for example, OTP input)
      } else {
        // Handle error response
        setErrorMessage(response.data.responseInfo?.description);
      }
    } catch (error) {
      console.error("Error during resend:", error);
      setErrorMessage("An error occurred. Please try again later.");
    }

    // Set loading to false once the process is completed
    setLoading(false);
  };

  const submitOtp = async (e: any) => {
    setLoading(true);

    e.preventDefault();
    try {
      const response = await verifyResetOtp(
        emailValue,
        otp[0] + otp[1] + otp[2] + otp[3]
      );

      if (response.data.data) {
        showSnackbar(response.data.responseInfo?.description, "success");
        setStep(2);
        setErrorMessage("");
      } else {
        setErrorMessage(response.data.responseInfo?.description);
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
    setLoading(false);
  };

  const handleDone = (e: any) => {
    e.preventDefault();
    const token = localStorage.getItem("tempToken");
    localStorage.setItem("userId", token || "");
    navigate("/login");
    setStep(0);
  };

  const isValidEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
    emailValue
  );

  return (
    <div className="login_navbar_container">
      <HomeNavbar isHome={true} />
      <div className="main_login_container_ak">
        {/* <div className="login_background">
        <div className="login_overlay"></div>
      </div>{" "} */}

        <div className="login_content_wrapper">
          <div className="forgot_form_wrapper_ak">
            <div className="login">
              {step === 3 ? (
                <div className="forgot-form-container">
                  <img
                    src={images.tick03}
                    alt="otp_email"
                  />
                  <h2 className="text-center">
                    Success! Your password has been changed.
                  </h2>
                  <form className="login-form" onSubmit={handleDone}>
                    <div className="input-container">
                      <div className="submit-container">
                        <button className="submit-button" type="submit">
                          Back to Log in
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              ) : step === 2 ? (
                <div className="forgot-form-container">
                  <img
                    src={images.lock1}
                    alt="otp_email"
                  />
                  <h2 className="text-center">Create new password</h2>
                  <p className="text-center gray-text">
                    Set a secure and unique password for your account.
                  </p>
                  <CreatePasswordForm setStep={setStep} />
                </div>
              ) : step === 1 ? (
                <div className="forgot-form-container">
                  <img
                    src={images.otpemail}
                    alt="otp_email"
                  />
                  <h2 className="text-center">One-Time-Password email sent</h2>
                  <p className="text-center gray-text">
                    Enter the 4 digits that was sent to your email to reset your
                    password
                  </p>
                  <form
                    className="login-form textFieldWrapper"
                    onSubmit={submitOtp}
                  >
                    <div className="input-container">
                      <div className="otp_input_wrapper">
                        <input
                          key={0}
                          type="text"
                          maxLength={1}
                          value={otp[0]}
                          id={`otp-${0}`}
                          className="otp_input"
                          onChange={(e) => handleOtpChange(e, 0)}
                          autoFocus={true}
                        />
                        <input
                          key={1}
                          type="text"
                          maxLength={1}
                          value={otp[1]}
                          id={`otp-${1}`}
                          className="otp_input"
                          onChange={(e) => handleOtpChange(e, 1)}
                        />
                        <input
                          key={2}
                          type="text"
                          maxLength={1}
                          value={otp[2]}
                          id={`otp-${2}`}
                          className="otp_input"
                          onChange={(e) => handleOtpChange(e, 2)}
                        />
                        <input
                          key={3}
                          type="text"
                          maxLength={1}
                          value={otp[3]}
                          id={`otp-${3}`}
                          className="otp_input"
                          onChange={(e) => handleOtpChange(e, 3)}
                        />
                      </div>
                      <div className="errorMessage textCenter">
                        {errorMessage}
                      </div>

                      <div className="submit-container">
                        <button
                          className="submit-button"
                          type="submit"
                          disabled={submitDisabled}
                        >
                          Submit
                        </button>
                      </div>
                      <div className="backarrow-container">
                        <h1
                          onClick={() => !resendDisabled && resendCode()}
                          className="forgot-label"
                        >
                          {resendDisabled
                            ? `Resend code in ${countdown}s`
                            : "Resend code"}
                        </h1>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div className="forgot-form-container">
                  <h2 className="text-center">Reset your password</h2>
                  <p className="text-center gray-text">
                    Enter the email address associated with your account and we
                    will send you an OTP to reset your password.
                  </p>

                  <form
                    className="login-form textFieldWrapper"
                    onSubmit={handleSubmit(forgetPassword)}
                  >
                    <TextField
                      className="textFieldMargins"
                      label=""
                      fullWidth
                      placeholder="Email"
                      autoComplete="new-password"
                      {...register("email")}
                      error={!!formState.errors.email || !!errorMessage}
                      helperText={
                        formState.errors.email?.message || errorMessage
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img src={emailIcon} alt="email_icon" />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <br />
                    {showCreateBtn && (
                      <Link to={`/signup`} style={{ textDecoration: "none" }}>
                        {" "}
                        <h1 className="forgot-label">Create an account?</h1>
                      </Link>
                    )}
                    <div className="submit-container">
                      <button
                        className="submit-button"
                        type="submit"
                        disabled={!isValidEmail}
                      >
                        Continue
                      </button>
                    </div>
                    <Link to={`/login`} style={{ textDecoration: "none" }}>
                      <div className="backarrow-container">
                        <h1 className="forgot-label">Back to Log In</h1>
                      </div>
                    </Link>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
